var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisibilitySemiTransparent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.637 9.35028a5.76188 5.76188 0 0 1 -1.25577-1.35028 5.59261 5.59261 0 0 1 1.42114-1.58813 8.2766 8.2766 0 0 1 2.67132-2.40119 7.25783 7.25783 0 0 0 -5.47369 3.98932 7.25783 7.25783 0 0 0 5.47369 3.98932 8.2897 8.2897 0 0 1 -2.83669-2.63904z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.5 3.9375a7.23683 7.23683 0 0 0 -6.5 4.0625 7.23125 7.23125 0 0 0 13 0 7.23683 7.23683 0 0 0 -6.5-4.0625zm3.16875 2.1125a5.60161 5.60161 0 0 1 1.95 1.95 6.81849 6.81849 0 0 1 -1.86875 1.86875 5.60136 5.60136 0 0 1 -3.16875.975 5.4169 5.4169 0 0 1 -3.16875-.975 5.666 5.666 0 0 1 -2.03125-1.86875 5.60161 5.60161 0 0 1 1.95-1.95c.08125 0 .08125-.08125.1625-.08125a2.59516 2.59516 0 0 0 -.24375 1.1375 3.25 3.25 0 1 0 6.5 0 5.48643 5.48643 0 0 0 -.1625-1.1375zm-3.16875.65a1.21875 1.21875 0 1 1 -1.21875-1.21875 1.19656 1.19656 0 0 1 1.21875 1.21875z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilitySemiTransparent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visibility-semi-transparent.b5280959b89c0e5997da6ce654a6e70f.svg";